angular
    .module("elogbooksServices")
    .service("chainIdService", function (base64) {
        "use strict";

        this.generateChainId = function (token) {
            try {
                if (!token) {
                    return null;
                }
                // Get system name from hostname
                let systemName = window.location.hostname.substring(
                    0,
                    window.location.hostname.indexOf(".")
                );
                if (!systemName) {
                    systemName = "local"; // fallback for local development
                }
                // decode jwt token and get username, user_id from payload
                const decodedToken = JSON.parse(atob(token.split(".")[1]));
                const userId = decodedToken.user_id || "";
                const userName = decodedToken.username || "";
                const chainIdString = [systemName, userName, userId].join(":");

                // Base64 encode
                return base64.encode(chainIdString);
            } catch (error) {
                return null;
            }
        };
    });
